import { Skeleton } from 'element-ui'

const YSkeleton = Skeleton
YSkeleton.$depends = [Skeleton]
YSkeleton.$name = 'y-skeleton'
YSkeleton._name = 'Skeleton 骨架屏'

export default YSkeleton
